import { Typography } from '@module/components/Typography/Typography';
import SettingConfig from '../../config/setting';

const getRankChangeImage = (preRankingNumber: number, rankingNumber: number) => {
  const diff = rankingNumber - preRankingNumber;
  const isNew = preRankingNumber === 0;

  if (isNew) {
    return (
      <div className='flex w-[34px] items-center justify-center'>
        <Typography variant='caption-1' weight={'bold'} color={'red1'} asChild>
          <span>NEW</span>
        </Typography>
      </div>
    );
  }

  if (diff < 0) {
    return (
      <div className='flex w-[34px] items-center justify-center'>
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/fanza_icon_rank_up.png`}
          alt='icon_rank_up'
          width={12}
          height={12}
        />
        <Typography variant='caption-1' weight={'bold'} color={'red1'} asChild>
          <span>{Math.abs(diff)}</span>
        </Typography>
      </div>
    );
  }

  if (diff > 0) {
    return (
      <div className='flex w-[34px] items-center justify-center'>
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/fanza_icon_rank_down.png`}
          alt='icon_rank_down'
          width={12}
          height={12}
        />
        <Typography variant='caption-1' weight={'bold'} color={'blue'} asChild>
          <span>{Math.abs(diff)}</span>
        </Typography>
      </div>
    );
  }

  return (
    <div className='flex w-[34px] items-center justify-center'>
      <img
        src={`${SettingConfig.S3_BUCKET_URL}/img/icon/icon_rank_flat.png`}
        alt='icon_rank_flat'
        width={12}
        height={12}
      />
    </div>
  );
};

export default getRankChangeImage;
